import { CustomerDataSource } from "@redotech/redo-model/marketing/segments/segment-types";
import { Provider } from "@redotech/redo-model/order";

/**
 * Converts Provider enum values to CustomerDataSource enum values.
 * Always includes REDO as it's platform-agnostic.
 */
export function providersToDataSources(
  providers: Provider[],
): CustomerDataSource[] {
  const sources: CustomerDataSource[] = [CustomerDataSource.REDO];

  if (providers.includes(Provider.SHOPIFY)) {
    sources.push(CustomerDataSource.SHOPIFY);
  }

  if (providers.includes(Provider.COMMENTSOLD)) {
    sources.push(CustomerDataSource.COMMENTSOLD);
  }

  return sources;
}
